module.exports = __webpack_public_path__ + "static/media/email-black.ea90ec27.png";